import CategoryModalCollapse from './CategoryModalCollapse'
export default CategoryModalCollapse
